import httpClient from "./httpClient";
import { User, CreatedUser, DefaultUser, UserConfig } from "../types/users";
import { Hospital } from "../types/hospitals";
import { Organisation } from "../types/organisation";
import { Listing } from "../types/listings";
import { Group } from "../types/groups";
import { Layout } from "../types/layouts";

const END_POINT = "/users";

const getUsers = async (): Promise<User[] | undefined> => {
	const response = await httpClient.get(END_POINT);
	return response.data as User[];
};

const getUser = async (id: number): Promise<User | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}`);
	return response.data as User;
};

const createUser = async (user: User): Promise<CreatedUser | undefined> => {
	const response = await httpClient.post(`${END_POINT}/old`, user);
	return response.data as CreatedUser;
};

const getOrganisation = async (
	id: number
): Promise<Organisation | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/organisation`);
	return response.data as Organisation;
};

const getListings = async (id: number): Promise<Listing[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/listings`);
	return response.data as Listing[];
};

const getHospital = async (id: number): Promise<Hospital | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/hospital`);
	return response.data as Hospital;
};

const getGroups = async (id: number): Promise<Group[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/groups`);
	return response.data as Group[];
};

const putUser = async (user: User): Promise<User | undefined> => {
	const { id } = user;
	const response = await httpClient.put(`${END_POINT}/${id}`, user);
	return response.data as User;
};

const getDashboards = async (id: number): Promise<Layout[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/dashboards`);
	return response.data as Layout[];
};

const postDashboards = async (id: number, dashboardids: number[]) => {
	const response = await httpClient.post(
		`${END_POINT}/${id}/dashboards`,
		dashboardids
	);
	return response.data;
};

const postListings = async (id: number, lisitngids: number[]) => {
	const response = await httpClient.post(
		`${END_POINT}/${id}/listings`,
		lisitngids
	);
	return response.data;
};

const postGroups = async (id: number, groupids: number[]) => {
	const response = await httpClient.post(`${END_POINT}/${id}/groups`, groupids);
	return response.data;
};

const resendInvite = (id: number) => {
	httpClient.post(`${END_POINT}/${id}/resendinvite`);
};

const getInvites = async (id: number): Promise<any[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}/invites`);
	return response.data as any[];
};

const getConfig = async (id: number): Promise<UserConfig | undefined> => {
	const response = await httpClient.get(`/users/${id}/config`);
	return response.data as UserConfig;
};

const putConfig = async (
	id: number,
	config: UserConfig
): Promise<UserConfig | undefined> => {
	const response = await httpClient.put(`/users/${id}/config`, config);
	return response.data as UserConfig;
};

export {
	createUser,
	getDashboards,
	getGroups,
	getHospital,
	getListings,
	getOrganisation,
	getUser,
	getUsers,
	postDashboards,
	postListings,
	putUser,
	postGroups,
	resendInvite,
	getInvites,
	getConfig,
	putConfig
};
